module.exports = __webpack_public_path__ + "img/plane-b737v4.71b6772e.svg";